/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Plan_Dose_Hold_OnlyInputs */

const en_us2_plan_dose_hold_only = /** @type {(inputs: Plan_Dose_Hold_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s hold`)
};

const pt_br2_plan_dose_hold_only = /** @type {(inputs: Plan_Dose_Hold_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s de sustentação`)
};

const es_419_plan_dose_hold_only = /** @type {(inputs: Plan_Dose_Hold_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s sosteniendo`)
};

const pt_pt2_plan_dose_hold_only = /** @type {(inputs: Plan_Dose_Hold_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s de sustentação`)
};

const fr_fr2_plan_dose_hold_only = /** @type {(inputs: Plan_Dose_Hold_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s de maintien`)
};

const de_de2_plan_dose_hold_only = /** @type {(inputs: Plan_Dose_Hold_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s halten`)
};

const it_it2_plan_dose_hold_only = /** @type {(inputs: Plan_Dose_Hold_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s di tenuta`)
};

/**
* | output |
* | --- |
* | "{seconds} s hold" |
*
* @param {Plan_Dose_Hold_OnlyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_dose_hold_only = /** @type {((inputs: Plan_Dose_Hold_OnlyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Dose_Hold_OnlyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_dose_hold_only(inputs)
	if (locale === "es-419") return es_419_plan_dose_hold_only(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_dose_hold_only(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_dose_hold_only(inputs)
	if (locale === "de-DE") return de_de2_plan_dose_hold_only(inputs)
	if (locale === "it-IT") return it_it2_plan_dose_hold_only(inputs)
	return en_us2_plan_dose_hold_only(inputs)
});
export { plan_dose_hold_only as "plan.dose_hold_only" }